module.exports = __webpack_public_path__ + "img/80.4a5bc1d0.jpg";